class SidebarAccordion {
  constructor() {
    this.accordions = document.querySelectorAll('.main-sidebar-link__accordion:not([data-initialized])');
    this.init();
  }

  init() {
    this.accordions.forEach((accordion) => {
      const button = accordion.querySelector('.main-sidebar-link__title-wrapper');
      const children = accordion.querySelector('.main-sidebar-link__children');
      
      if (!button || !children) return;

      // Mark as initialized to prevent duplicate handlers
      accordion.setAttribute('data-initialized', 'true');

      // Check if accordion should be open by default
      const shouldBeOpen = accordion.classList.contains('is-open');
      
      if (shouldBeOpen) {
        // Keep it open - just ensure proper attributes are set
        button.setAttribute('aria-expanded', 'true');
        children.style.height = 'auto';
      } else {
        // Set initial state - closed
        button.setAttribute('aria-expanded', 'false');
        accordion.classList.remove('is-open');
        this.setHeight(children, 0);
      }

      // Add click handler
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggleAccordion(accordion, button);
      });
    });
  }

  setHeight(element, height) {
    element.style.height = height + 'px';
  }

  toggleAccordion(accordion, button) {
    const isOpen = accordion.classList.contains('is-open');
    const children = accordion.querySelector('.main-sidebar-link__children');
    const inner = children.querySelector('.main-sidebar-link__children-inner');
    
    if (isOpen) {
      // Close accordion
      this.closeAccordion(accordion, button, children, inner);
    } else {
      // Open accordion
      this.openAccordion(accordion, button, children, inner);
    }
  }

  openAccordion(accordion, button, children, inner) {
    // Add open class immediately
    accordion.classList.add('is-open');
    button.setAttribute('aria-expanded', 'true');
    
    // Temporarily remove height restriction to measure actual content height
    children.style.height = 'auto';
    const targetHeight = children.scrollHeight;
    
    // Set height to 0 first for animation
    this.setHeight(children, 0);
    if (inner) {
      inner.style.opacity = '0';
    }
    
    // Force reflow
    void children.offsetHeight;
    
    // Animate to target height
    requestAnimationFrame(() => {
      this.setHeight(children, targetHeight);
      if (inner) {
        inner.style.opacity = '1';
      }
      
      // After animation, set to auto to handle dynamic content
      setTimeout(() => {
        if (accordion.classList.contains('is-open')) {
          children.style.height = 'auto';
        }
      }, 300);
    });
  }

  closeAccordion(accordion, button, children, inner) {
    // Get current height
    const currentHeight = children.scrollHeight;
    this.setHeight(children, currentHeight);
    
    // Force reflow
    void children.offsetHeight;
    
    // Remove open class and animate to 0
    accordion.classList.remove('is-open');
    button.setAttribute('aria-expanded', 'false');
    
    requestAnimationFrame(() => {
      this.setHeight(children, 0);
      if (inner) {
        inner.style.opacity = '0';
      }
    });
  }
}

// Calculate and set nav spacing CSS variable
function setNavSpacing() {
  const sidebar = document.querySelector('.new-sidebar');
  const sidebarNav = document.querySelector('.new-sidebar__nav');
  if (sidebar && sidebarNav) {
    const rect = sidebar.getBoundingClientRect();
    const spacing = rect.top;
    sidebarNav.style.setProperty('--nav-spacing', `${spacing}px`);
    
  }
}

// Initialize when DOM is ready
function initSidebarAccordion() {
  const accordions = document.querySelectorAll('.main-sidebar-link__accordion');
  if (accordions.length > 0) {
    new SidebarAccordion();
  }
}

// Initialize sidebar functionality
function initSidebar() {
  initSidebarAccordion();
  setNavSpacing();
}

// Try multiple initialization methods to ensure it works
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSidebar);
} else {
  // DOM already loaded
  initSidebar();
}

// Also try after a short delay in case content loads dynamically
setTimeout(initSidebar, 100);

// Update nav spacing on scroll and resize
let resizeTimer;
window.addEventListener('scroll', () => {
  setNavSpacing();
});

window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    setNavSpacing();
  }, 100);
});

// Re-initialize if new accordions are added dynamically
if (typeof MutationObserver !== 'undefined') {
  const observer = new MutationObserver(() => {
    const newAccordions = document.querySelectorAll('.main-sidebar-link__accordion:not([data-initialized])');
    if (newAccordions.length) {
      initSidebarAccordion();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

